import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '../../components/common/BrandLogo';
import { useAuth } from '../../context/AuthContext';

export default function ForgotPasswordPage() {
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await requestPasswordReset(email.trim());
    } catch {
      // Always show the same confirmation to avoid revealing registered emails.
    } finally {
      setSubmitted(true);
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--bg-base)] flex flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10">
          <BrandLogo size="lg" />
        </div>

        <div className="bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-3xl p-8 shadow-sm">
          <h1 className="text-2xl font-black text-[var(--text-main)] uppercase italic tracking-tight mb-2 text-center">
            Recuperar contraseña
          </h1>
          <p className="text-xs text-[var(--text-secondary)] text-center mb-8 uppercase tracking-widest">
            Te enviaremos un enlace para restablecerla
          </p>

          {submitted ? (
            <div className="space-y-6">
              <p className="text-sm text-brand-green font-medium text-center leading-relaxed">
                Si existe una cuenta con ese email, recibirás un enlace para restablecer tu contraseña.
                Revisa tu bandeja de entrada y la carpeta de spam.
              </p>
              <Link
                to="/login"
                className="block w-full text-center gfi-gradient-bg text-brand-navy py-4 rounded-xl font-black text-xs uppercase tracking-widest transition-all hover:scale-[1.02]"
              >
                Volver a iniciar sesión
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-[10px] font-black text-[var(--text-secondary)] uppercase tracking-widest mb-2">
                  Email
                </label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-[var(--bg-base)] border border-[var(--border-subtle)] rounded-xl py-3 px-4 text-sm text-[var(--text-main)] focus:outline-none focus:border-brand-cyan focus:ring-1 focus:ring-brand-cyan"
                />
              </div>

              <button
                type="submit"
                disabled={submitting}
                className="w-full gfi-gradient-bg text-brand-navy py-4 rounded-xl font-black text-xs uppercase tracking-widest transition-all hover:scale-[1.02] disabled:opacity-60"
              >
                {submitting ? 'Enviando...' : 'Enviar enlace'}
              </button>
            </form>
          )}

          {!submitted && (
            <p className="text-center text-xs text-[var(--text-secondary)] mt-8">
              ¿Recordaste tu contraseña?{' '}
              <Link to="/login" className="text-brand-cyan font-bold hover:underline">
                Inicia sesión
              </Link>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
